import { QueryClient } from '@tanstack/react-query';

/** The one query client, exported so the sandbox can clear it from outside React. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, staleTime: 30_000, retry: 1 },
  },
});
